import { getUniqueLocations, hasCoords, toGeofence } from '../Geolocation';
import { isAtDoctor, isAtHome, isAtPharmacy } from '../../util/notifications';
import { GEO_DEBUG } from './util';

export const getGeofences = ({ frequencyNotificationTemplates, ...rest }) => {
  const geofences = [];
  frequencyNotificationTemplates.forEach(notificationTemplate => {
    GEO_DEBUG && console.log(notificationTemplate, rest);

    const allLocations = getLocations({ notificationTemplate, ...rest });
    const uniqueLocations = getUniqueLocations(allLocations);

    uniqueLocations.forEach(location => {
      geofences.push(createGeofence(location, notificationTemplate));
    });
  });

  return geofences;
};

const getLocations = ({
  notificationTemplate,
  doctors,
  homeAddresses,
  pharmacies,
}) => {
  const { locationTypeId } = notificationTemplate;
  let locations = [];

  if (isAtDoctor(locationTypeId)) locations = doctors;
  if (isAtDoctor(locationTypeId)) locations = doctors;
  if (isAtHome(locationTypeId)) locations = homeAddresses;
  if (isAtPharmacy(locationTypeId)) locations = pharmacies;

  return locations.filter(hasCoords);
};

const createGeofence = (location, notificationTemplate) =>
  toGeofence({
    identifier: `LocationTypeID-${
      notificationTemplate.locationTypeId
    }:TemplateID-${notificationTemplate.id}:Location-${location.id}`,
    idleTime: notificationTemplate.idleTime,
    latitude: location.latitude,
    longitude: location.longitude,
    extras: {
      location,
      notificationTemplate,
    },
  });

export const meetsUserSettings = (geofence, settings) => {
  const locationTypeId = geofence.extras.notificationTemplate.locationTypeId;
  return (
    (settings.atDoctor && isAtDoctor(locationTypeId)) ||
    (settings.atHome && isAtHome(locationTypeId)) ||
    (settings.atPharmacy && isAtPharmacy(locationTypeId))
  );
};



// WEBPACK FOOTER //
// ./src/modules/Geolocation/geofenceHelpers.js